import ReactGA from 'react-ga4';

// 環境変数の確認
const isProduction = process.env.REACT_APP_ENV === 'production';

// Google Analyticsの初期化
export const initGA = () => {
  if (isProduction) {
    ReactGA.initialize('G-LVX8B8QDSF', {
      gaOptions: {
        cookieFlags: 'SameSite=None;Secure'
      }
    });
  }
};

// ページビューの送信（リファラー情報を含む）
export const sendPageView = (path: string) => {
  if (isProduction) {
    // リファラー情報を取得
    const referrer = document.referrer;
    
    ReactGA.send({ 
      hitType: 'pageview', 
      page: path,
      referrer: referrer // リファラー情報を追加
    });
  }
};

// リファラー情報のトラッキング（特定のケースでより詳細な情報が必要な場合用）
export const trackReferrer = () => {
  if (isProduction && document.referrer) {
    const referrer = document.referrer;
    const referrerDomain = new URL(referrer).hostname;
    
    // リファラードメイン別のイベントを送信
    sendEvent('referrer', 'visit', referrerDomain);
  }
};

// イベントの送信（記事閲覧などの特定アクションに使用可能）
export const sendEvent = (category: string, action: string, label?: string, value?: number) => {
  if (isProduction) {
    ReactGA.event({
      category,
      action,
      label,
      value
    });
  }
};

// 記事ページビューのトラッキング
export const trackArticleView = (slug: string, title: string) => {
  if (isProduction) {
    // ページビュー送信
    sendPageView(`/article/${slug}`);
    
    // 追加の記事閲覧イベント送信
    sendEvent('article', 'view', title);
    
    // リファラー情報も記録
    trackReferrer();
  }
}; 